import React, { useState, useContext, useEffect } from 'react'
import AdminContext from '../../../StateContext/Application';
import "../../page.css"
import { ApproveRequest, Cancel32, Close32, DeleteRed32, EditBlueBlue32, submit } from '../../../../../public/LoginImages/importimages';
const RequisitionsList = () => {
  const context = useContext(AdminContext);
  const { GetProjectsDetails, AddExpenses, ApprovedOrRejectExpense } = context;
  const [expenses, setExpenses] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [approvedAmount, setApprovedAmount] = useState('');
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectingExpense, setRejectingExpense] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 10;

const indexOfLastBill = currentPage * itemsPerPage;
const indexOfFirstBill = indexOfLastBill - itemsPerPage;
const currentExpenses = expenses.slice(indexOfFirstBill, indexOfLastBill);
const totalPages = Math.ceil(expenses.length / itemsPerPage);

  useEffect(() => {
    GetExpenses();
  }, [])
  const GetExpenses = async () => {
    try {
      let data = await AddExpenses([], "get");
      setExpenses(data);
    } catch (error) {
      console.error("Error in GetProjects:", error);
    }
  };

  

  return (
    <>
      <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f4f7fe', overflowY: 'auto', maxHeight: '91vh', padding: '0px 0px 20px 0px' }}>

        <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px" }}>
          <div style={{ display: 'grid', justifyContent: 'center', width: '75vw', borderRadius: '20px', backgroundColor: 'white', padding: '2rem', }}>
            <h5 className='my-4' style={{ background: 'linear-gradient(to bottom, #3b409e, #0067ab, #0f79ba, #0098d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: '700', }}>Requisitions Request</h5>
            <div style={{ display: 'flex', justifyContent: 'center', width: '70vw', backgroundColor: '#e8f7f3', border: '1px solid darkgray' }}>
              <table style={{ backgroundColor: '#e8f7f3', width: '100%' }}>
                <thead>
                  <tr style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', height: '2.5rem' }}>
                    <th>Sr.No.</th>
                    <th>Request Id</th>
                    <th>Project Name</th>
                    <th>User Name</th>
                    <th>Expense Type</th>
                    <th>Requested Amount</th>
                    <th>Approved Amount</th>
                    <th>Description</th>
                    <th>Requested On</th>
                    <th>Status</th>
                    <th>Approve/Reject By</th>
                   
                  </tr>
                  {currentExpenses.map((expense, index) => (
                    <tr key={expense.id}>
                      <td>{index + 1}</td>
                      <td>{expense.Request_Id}</td>
                      <td>{expense.Project_Name}</td>
                      <td>{expense.User_Name}</td>
                      <td>{expense.Expense_Type}</td>
                      <td>{expense.Amount}</td>
                      <td>{expense.Approved_Amount}</td>
                      <td>{expense.Description}</td>
                      <td>{expense.Date}</td>
                      <td>{expense.Status}</td>
                      <td>{expense.Approved_By}</td>
                    </tr>
                  ))}
                </thead>
              </table>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 3rem', height: '3rem', alignItems: 'center' }}>
                <div>
                <p>Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, expenses.length)} of {expenses.length} entries</p>

                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
      </div>
    </>
  )
}

export default RequisitionsList